import axios from 'axios';

const filterBid = ({ filters }) => axios.get('bid', {
  params: filters,
});
const getBid = ({ bidId }) => axios.get(`/bid/${bidId}`);
const placeBid = bidBody => axios.post('bid', { ...bidBody });
const updateBid = ({ bidId, body }) => axios.post(`bid/${bidId}`, body);
const deleteBid = ({ bidId }) => axios.delete(`bid/${bidId}`);
const acceptBid = ({ bidId, numberOfLoads }) => axios.post(`bid/${bidId}/accept`, { numberOfLoads });
const getConversation = ({ bidId }) => axios.get(`timeline/bid/${bidId}`);
const updateBidTimeline = ({ bidId, messageRequest }) => axios.post(`timeline/bid/${bidId}`, messageRequest);
const uploadBidPhoto = ({ bidId, name, photoBase64s, config }) =>
  axios.post(`timeline/bid/${bidId}/file`, {
    message: name,
    base64EncodedData: photoBase64s[0][0],
    sent: new Date().toISOString(),
  }, config);

export default {
  getBid,
  filterBid,
  placeBid,
  updateBid,
  acceptBid,
  deleteBid,
  getConversation,
  updateBidTimeline,
  uploadBidPhoto,
};



// WEBPACK FOOTER //
// ./src/api/bid.js